export default __webpack_public_path__ + "static/media/message-overlay-mobile-vertical.e441b37a.png";